// AS-11593: To + CC rules for the Send PO dialog. The de-duplication and the
// cap mirror assisty-bot's purchase_order_controller.sendToEmail, so the dialog
// blocks an over-cap send before the API rejects it with a 400.

type Rule = (v: string[]) => boolean | string;
type EmailValidator = (email: string) => boolean;

const MAX_RECIPIENTS = 5;
const COMBINED_CAP_MESSAGE = `Maximum ${MAX_RECIPIENTS} recipients allowed (To + CC)`;

/**
 * CC addresses that repeat each other or a To address are dropped,
 * case-insensitively. Each address only needs one copy, and SendGrid rejects
 * the same address in both `to` and `cc`.
 */
export function uniqueCcRecipients(to: string[], cc: string[]): string[] {
  const seen = new Set(to.map((email) => String(email).toLowerCase()));
  return cc.filter((email) => {
    const key = String(email).toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function toRecipientsRules(cc: string[], isValidEmail: EmailValidator): Rule[] {
  return [
    (v: string[]) => v.length > 0 || 'At least one recipient is required',
    (v: string[]) => {
      const ccCount = uniqueCcRecipients(v, cc).length;
      if (v.length + ccCount <= MAX_RECIPIENTS) return true;
      return ccCount > 0 ? COMBINED_CAP_MESSAGE : `Maximum ${MAX_RECIPIENTS} recipients allowed`;
    },
    (v: string[]) => v.every((email) => isValidEmail(email)) || 'Invalid email format',
  ];
}

export function ccRecipientsRules(to: string[], isValidEmail: EmailValidator): Rule[] {
  return [
    (v: string[]) => to.length + uniqueCcRecipients(to, v).length <= MAX_RECIPIENTS || COMBINED_CAP_MESSAGE,
    (v: string[]) => v.every((email) => isValidEmail(email)) || 'Invalid email format',
  ];
}
